export default __webpack_public_path__ + "static/media/evento-3.1727cd47.jpg";